import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Col, Container, Modal, ModalBody, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import useMobile from '../../../hooks/useMobileHook';

export type FormsOfPaymentProps = React.PropsWithChildren<{
  showFormsOfPaymentModal: boolean;
  handleCloseFormsOfPaymentModal: () => void;
  modalData: any;
}>;

const FormsOfPaymentModal = ({
  showFormsOfPaymentModal,
  handleCloseFormsOfPaymentModal,
  modalData,
}: FormsOfPaymentProps) => {
  const isMobile = useMobile();

  return (
    <Modal
      fullscreen={isMobile}
      size={'xl'}
      show={showFormsOfPaymentModal}
      onHide={handleCloseFormsOfPaymentModal}
    >
      <Modal.Header className={'no-border pb-10'} closeButton>
        <Container className={'text-start px-0'}>
          <h2 className={'text-sm-20-lg-32 fw-light mb-0'}>Forms of Payment</h2>
        </Container>
      </Modal.Header>
      <ModalBody className={'pt-0'}>
        <>
          <Row className={'justify-content-end'}>
            <Col className={'col-12 col-lg-3 text-end'}>
              <Container className={'px-0 w-100'}>
                <a
                  className={'text-decoration-none'}
                  href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                  target={'_blank'}
                  rel="noreferrer"
                >
                  <Button
                    className={'w-100'}
                    size={'sm'}
                    leftIcon={light('file-download')}
                    variant={'primary-outline'}
                  >
                    Download Summary
                  </Button>
                </a>
              </Container>
            </Col>
          </Row>

          <Container className={'px-0 overflow-auto'}>
            <Container
              className={'px-0 overflow-hidden'}
              style={{ minWidth: 650 }}
            >
              <Row className={'mt-11 py-5 border-bottom-dark-gray'}>
                <Col className={'col-6'}>
                  <span className={'text-fs-6 fw-normal text-light-grey'}>
                    Form of Payment
                  </span>
                </Col>
                <Col className={'col-3'}>
                  <span className={'text-fs-6 fw-normal text-light-grey'}>
                    Monthly Payment Payable to You
                  </span>
                </Col>
                <Col className={'col-3'}>
                  <span className={'text-fs-6 fw-normal text-light-grey'}>
                    Monthly Payment to Beneficiary After Death
                  </span>
                </Col>
              </Row>

              {modalData.map((paymentData: any, i: number) => {
                return (
                  <Row className={'border-bottom-light-gray-lg'} key={i}>
                    <Col className={'col-12 pt-3 pb-1'}>
                      <Row className={'py-1'}>
                        <Col className={'col-6'}>
                          <span className={'fw-normal text-fs-6'}>
                            {paymentData.title}
                          </span>
                        </Col>
                        <Col className={'col-3'}>
                          <span className={'fw-light text-fs-6'}>
                            {paymentData.contributionsWithdrawn.monthlyPayment}
                          </span>
                        </Col>
                        <Col className={'col-3'}>
                          <span className={'fw-light text-fs-6'}>
                            {
                              paymentData.contributionsWithdrawn
                                .monthlyPaymentToBeneficiary
                            }
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                );
              })}
            </Container>
          </Container>

          <Modal.Footer className={'pt-0 mt-12'}>
            <Button
              variant="primary-outline"
              onMouseDown={handleCloseFormsOfPaymentModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </>
      </ModalBody>
    </Modal>
  );
};

export default FormsOfPaymentModal;
